import { connectRouter } from 'connected-react-router';
import { combineReducers } from '@reduxjs/toolkit';

import { history } from 'app/lib/router';
// client-side only reducers
import { signalrReducer } from 'app/lib/signalr';
import betSlip from 'app/modules/BetSlip/reducer';
import liveStream from 'app/modules/LiveStream/reducer';

import { connectPersistence } from '../persistence';
import { getUniversalReducers } from './universal';

const rootReducer = function (flags) {
  return combineReducers({
    router: connectRouter(history),
    ...getUniversalReducers(flags),
    signalr: signalrReducer,
    liveStream,
    betSlip,
  });
};

export default function getRootReducer(flags) {
  return connectPersistence(rootReducer(flags));
}
